import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { RoomsProvider } from "@/lib/contexts/rooms-context";
import { StudioContextProvider } from "@/lib/contexts/studio-context";
import { Outlet, useLocation } from "react-router-dom";
import { AppSidebar } from "./app-sidebar";

const breadcrumbMap: Record<string, string> = {
  "/owner/dashboard": "Dashboard",
  "/owner/studio/setup": "Studio Setup",
  "/owner/rooms": "Rooms",
  "/owner/rooms/new": "Add Room",
  "/owner/bookings": "Rentals",
  "/owner/settings": "Settings",
  "/owner/help": "Help Center",
};

export function OwnerLayout() {
  const location = useLocation();

  const getBreadcrumbTitle = () => {
    if (
      location.pathname.includes("/owner/rooms/") &&
      location.pathname.includes("/edit")
    ) {
      return "Edit Room";
    }
    if (
      location.pathname.includes("/owner/bookings/") &&
      location.pathname !== "/owner/bookings"
    ) {
      return "Rental Details";
    }
    return breadcrumbMap[location.pathname] || "Dashboard";
  };

  return (
    <StudioContextProvider>
      <RoomsProvider>
        <SidebarProvider>
          <AppSidebar />
          <SidebarInset>
            <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
              <SidebarTrigger className="-ml-1" />
              <Separator orientation="vertical" className="mr-2 h-4" />
              <Breadcrumb>
                <BreadcrumbList>
                  <BreadcrumbItem className="hidden md:block">
                    <BreadcrumbLink asChild>
                      <span className="pointer-events-none text-on-dark-muted">
                        Studio Portal
                      </span>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator className="hidden md:block" />
                  <BreadcrumbItem>
                    <BreadcrumbPage>{getBreadcrumbTitle()}</BreadcrumbPage>
                  </BreadcrumbItem>
                </BreadcrumbList>
              </Breadcrumb>
            </header>
            <div className="flex flex-1 flex-col gap-4 px-2 py-3 sm:p-4">
              <Outlet />
            </div>
          </SidebarInset>
        </SidebarProvider>
      </RoomsProvider>
    </StudioContextProvider>
  );
}
